import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { colspan: "3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, null, -1)

import { useLeaveStore, uwvMaximumDagloon, YearMonth, yearMonthKey } from '@/stores/leave'
import Money from '@/components/Money.vue'
import DaysWithMissedIncome from '@/components/DaysWithMissedIncome.vue'
import Tooltip from '@/components/Tooltip.vue'
import { formatMoney } from '@/helpers/formatMoney'
import RowWithInfo from '@/components/RowWithInfo.vue'
import { translate } from '@/helpers/translate'
import { computed } from 'vue'
import YearMonthRegulationInfo from '@/components/YearMonthRegulationInfo.vue'
import FinancialMonthRow from '@/components/FinancialMonthRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinancialMonthly',
  setup(__props) {

const leaveStore = useLeaveStore()
const { t } = translate()

const yearMonthLeaveDaysMom = computed(() => leaveStore.yearMonthLeaveDays(true))
const yearMonthLeaveDaysPartner = computed(() => leaveStore.yearMonthLeaveDays(false))
const yearMonthRegulationsMom = computed(() => leaveStore.yearMonthRegulations(true))
const yearMonthRegulationsPartner = computed(() => leaveStore.yearMonthRegulations(false))
const yearMonthIncomeMom = computed(() => leaveStore.yearMonthIncome(true))
const yearMonthIncomePartner = computed(() => leaveStore.yearMonthIncome(false))
const yearMonths = computed(() => leaveStore.yearMonths || [])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.$style.title)
        }, "Gross monthly income", 2)
      ])
    ]),
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createElementVNode("th", null, _toDisplayString(_unref(t)('financialThMom')), 1),
      _createElementVNode("th", null, _toDisplayString(_unref(t)('financialThPartner')), 1),
      _createElementVNode("th", {
        class: _normalizeClass(_ctx.$style.total)
      }, "Total", 2)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearMonths), (yearMonth) => {
      return (_openBlock(), _createBlock(FinancialMonthRow, {
        yearMonth: yearMonth,
        incomeMom: _unref(yearMonthIncomeMom),
        incomePartner: _unref(yearMonthIncomePartner),
        "leave-days-mom": _unref(yearMonthLeaveDaysMom),
        "leave-days-partner": _unref(yearMonthLeaveDaysPartner),
        "regulations-mom": _unref(yearMonthRegulationsMom),
        "regulations-partner": _unref(yearMonthRegulationsPartner)
      }, null, 8, ["yearMonth", "incomeMom", "incomePartner", "leave-days-mom", "leave-days-partner", "regulations-mom", "regulations-partner"]))
    }), 256))
  ], 64))
}
}

})